import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";

interface Props {
  totalSteps: number;
  currentStep: number;
}

const Breadcrumb: React.FC<Props> = ({ totalSteps, currentStep }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="flex items-center gap-2">
      {new Array(totalSteps).fill(".").map((step, stepIndex) => (
        <div
          key={`${step}-${stepIndex}`}
          className="h-[10px] w-[48px] rounded-md"
          style={{ background: stepIndex <= currentStep - 1 ? "#1F8475" : theme.certVesselSelect.tabsBg }}
        />
      ))}
      <p className="text-[11px] font-semibold text-[#1F8475]">{`${currentStep}/${totalSteps}`}</p>
    </div>
  );
};

export default Breadcrumb;
